import React, { useEffect, useState, useContext } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";

const ipv4WithCidrRegex =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[12][0-9]|3[0-2]))?$/;

const TagInput = ({
  tags,
  onTagsChange,
  placeholder,
  label,
  valueType,
  suggestions = [],
  variant,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [isValid, setIsValid] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { t } = useContext(TranslationsContext);

  useEffect(() => {
    const newSuggestions = suggestions.filter(
      (sug) => !tags.some((tag) => tag.id === sug.id)
    );

    if (
      JSON.stringify(newSuggestions) !== JSON.stringify(filteredSuggestions)
    ) {
      setFilteredSuggestions(newSuggestions);
    }
  }, [tags, suggestions]);

  const addTag = (tag) => {
    console.log("Adding tag:", tag);
    if (tag.type === "ip") {
      if (!tags.some((t) => t === tag) && isValidTag(tag.naziv)) {
        onTagsChange([...tags, tag.naziv]);
        setInputValue("");
        setIsValid(true);
        setSelectedIndex(-1);
      } else if (!isValidTag(tag.naziv)) {
        setIsValid(false);
      }
    } else if (!tags.some((t) => t.id === tag.id) && isValidTag(tag.naziv)) {
      onTagsChange([...tags, tag]);
      setInputValue("");
      setIsValid(true);
      setSelectedIndex(-1);
    } else if (!isValidTag(tag.naziv)) {
      setIsValid(false);
    }
  };

  const removeTag = (indexToRemove) => {
    // Positional removal — works for both plain-string tags (e.g. ip_opseg,
    // which have no .id) and object tags, and only pops the clicked pill
    // even if two tags share the same value/id.
    onTagsChange(tags.filter((_, index) => index !== indexToRemove));
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value) {
      // Pretraga sada koristi includes(), tako da predlozi ostaju vidljivi čak i ako unos nije na početku
      const filtered = suggestions.filter(
        (sug) =>
          sug.naziv.toLowerCase().includes(value.toLowerCase()) &&
          !tags.some((t) => t.id === sug.id)
      );
      setFilteredSuggestions(filtered);
      setSelectedIndex(-1);
    } else {
      setFilteredSuggestions(
        suggestions.filter((sug) => !tags.some((t) => t.id === sug.id))
      );
    }

    setIsValid(isValidTag(value));
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((prevIndex) =>
        prevIndex < filteredSuggestions.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredSuggestions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (selectedIndex >= 0 && selectedIndex < filteredSuggestions.length) {
        const selectedSuggestion = filteredSuggestions[selectedIndex];
        addTag(selectedSuggestion);
      } else if (inputValue) {
        // Sada pretraga pronalazi predloge koji sadrže inputValue
        const matchedSuggestion = suggestions.find(
          (sug) => sug.naziv.toLowerCase().includes(inputValue.toLowerCase()) // Promena ovde
        );

        if (matchedSuggestion) {
          addTag(matchedSuggestion);
        } else if (valueType === "ip" && ipv4WithCidrRegex.test(inputValue)) {
          addTag({ naziv: inputValue, type: "ip" });
        } else {
          setIsValid(false);
        }
      }

      setInputValue("");
      if (e.key !== "Enter") {
        setShowSuggestions(false);
      }
      setSelectedIndex(-1);
    }
  };
  const handleBlur = () => {
    setTimeout(() => setShowSuggestions(false), 150); // delay zbog klika na sugestiju
    setIsValid(isValidTag(inputValue));
  };

  const isValidTag = (tagName) => {
    if (valueType === "ip") {
      return ipv4WithCidrRegex.test(tagName);
    }
    // Umesto tačnog poklapanja, koristimo includes() za fleksibilnije pretrage
    return suggestions.some((sug) =>
      sug.naziv.toLowerCase().includes(tagName.toLowerCase())
    );
  };

  const handleFocus = () => {
    setShowSuggestions(true);
    setFilteredSuggestions(
      suggestions.filter((sug) => !tags.some((t) => t.id === sug.id))
    );
  };

  return (
    <div className="flex-direction-column gap-8 width-100 tag-input-container">
      <div className="flex-direction-row gap-8 tags-wrapper">
        {label && (
          <label className="width-100 font-12 inria-sans-700">{label}</label>
        )}
        {tags?.map((tag, index) => (
          <div
            key={index}
            className="flex-direction-row gap-8 justify-center items-center height-100 tag"
          >
            <p className="font-12 inria-sans-400">
              {variant === "ip" ? tag : tag.naziv}
            </p>
            <img
              className="pointer remove-tag"
              src={icons.tag_x}
              alt="X"
              onClick={() => removeTag(index)}
            />
          </div>
        ))}
      </div>

      <div className="flex-direction-column gap-8 tag-input-suggestions">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder={placeholder}
          className={`inria-sans-400 font-12 ${
            inputValue && !isValid ? "invalid" : ""
          }`}
        />

        <p
          className={`enter-message font-12 inria-sans-400 ${
            !isValid ? "error-message" : ""
          }`}
          style={{ minHeight: "12px", color: "var(--text-black)" }}
        >
          {inputValue && (!isValid ? t("TAG_ERROR") : t("ENTER_TO_ADD"))}
        </p>

        {showSuggestions && filteredSuggestions.length > 0 && (
          <ul className="flex-direction-column width-100 suggestions">
            {filteredSuggestions.map((suggestion, index) => (
              <li
                className={`inria-sans-400 font-12 pointer ${
                  index === selectedIndex ? "selected" : ""
                }`}
                key={suggestion.id}
                onClick={() => addTag(suggestion)}
              >
                {suggestion.naziv}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default TagInput;
